module.exports = __webpack_public_path__ + "img/farming_22.5af9317c.png";